import { MainColor } from '../../palette/colors';

export const getProductionOrdersThemeConfig = () => {
  return {
    productionTime: {
      inactive: 'coolGrey60' satisfies MainColor as MainColor,
      active: 'navy95' satisfies MainColor as MainColor,
    },
    treeList: {
      borderlines: 'coolGrey30' satisfies MainColor as MainColor,
    },
    tableContainer: {
      highlight: 'coolGrey5' satisfies MainColor as MainColor,
      borderHighlight: 'coolGrey10' satisfies MainColor as MainColor,
    },
    list: {
      borderlines: 'coolGrey30' satisfies MainColor as MainColor,
      icons: 'coolGrey60' satisfies MainColor as MainColor,
    },
    simulation: {
      borderBottomColor: 'coolGrey10' satisfies MainColor as MainColor,
    },
    modal: {
      border: 'coolGrey10' satisfies MainColor as MainColor,
      background: 'coolGrey5' satisfies MainColor as MainColor,
    },
  };
};
export type ProductionOrdersTheme = ReturnType<typeof getProductionOrdersThemeConfig>;
